import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import i18n from './plugins/i18n'
import axios from 'axios'

const lang = localStorage.getItem('lang') || 'ja'
axios.defaults.baseURL = 'http://localhost:8080/'
axios.defaults.headers['Accept-Language'] = lang
Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
